// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + "dynamic-noty" + "." + "a53692fc" + ".chunk.js";
};